import { render, staticRenderFns } from "./checkCarInfo.vue?vue&type=template&id=2f70246e&scoped=true"
import script from "./checkCarInfo.vue?vue&type=script&lang=js"
export * from "./checkCarInfo.vue?vue&type=script&lang=js"
import style0 from "./checkCarInfo.vue?vue&type=style&index=0&id=2f70246e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f70246e",
  null
  
)

export default component.exports